
const state = {
  id: null,
  agency_id: null,
  enable_account_lock: false,
  notes: '',
  provider_id: null,
  terms: '',
}

export const requiredFields = [
  { key: 'agency_id' },
  { key: 'provider_id' },
]

export default state
